export const HOME_ATTENTION_COLLAPSED_LIMIT = 5;

export const HOME_ATTENTION_SKELETON_ROWS: readonly number[] = [0, 1, 2];
